<template>
	<div>
		<el-card class="box-card">
			 <div slot="header" class="clearfix">
                <div class="left">
                    <span @click="toBack" style="cursor: pointer">
						<i class="iconfont"></i>
						<span class="top_title">商品列表</span>
					</span>
					<span>
						<i class="iconfont">&#xe605;</i>
						<span class="top_title">商品详情</span>
					</span>
                </div>
            </div>
			<div class="proHead">
				<div class="left">
					<el-image v-if="imgs.length>0" :src="imgs[curIndex]" class="curImg" :preview-src-list="imgs">
					</el-image>
					<div v-else class="errorFonts" style="width:190px;height:190px">
						<div>暂无图片</div>
					</div>
					<div class="imgBox" v-if="imgs.length>0">
						<el-button class="prevbtn" type="text" icon="el-icon-arrow-left" @click="leftImg()"></el-button>
						<div class="imglist">
							<img v-for="(item,index) in imgs" :key="index" class="imgitem" v-show="index>=(curGroup-1)*5&&index<curGroup*5"
							 :src="imgs[index]" :class="{chooseImg:index===curIndex}" @click="curIndex=index">
						</div>
						<el-button class="nextbtn" type="text" icon="el-icon-arrow-right" @click="rightImg()"></el-button>
					</div>
				</div>
				<div class="right">
					<div class="proTitle">{{name}}</div>
					<div class="proInfo mt-12">
						<span>编码：{{number}}</span>
						<span>条形码：12345678932</span>
					</div>
					<div class="priceBox mt-12">
						<!-- <div>市场价：￥{{retail}}</div> -->
						<div>订货价：<span class="orderP">￥{{price}}</span></div>
					</div>
					<div class="listBox mt-12">
						<div class="label">颜色选择：</div>
						<div class="colorlist">
							<div class="coloritem" :class="{checkedColor:curColorIndex===index}" v-for="(item,index) in spec"
							 :key="index" @click="chooseColor(index)">
								{{item.color!=""?item.color:"默认"}}
								<img v-if="curColorIndex===index" src="../../assets/checked.png" width="11">
							</div>
						</div>
					</div>
					<div class="listBox">
						<div class="label">尺码选择：</div>
						<div class="colorlist" v-for="(cc,index) in spec" :key="index" v-show="index==curColorIndex">
							<div class="coloritem" :class="{checkedColor:curSizeIndex===index}" v-for="(item,index) in cc.sizes"
							:key="index" @click="chooseSize(index)">
								{{item!=""?item:"默认"}}
								<img v-if="curSizeIndex===index" src="../../assets/checked.png" width="11">
							</div>
						</div>
					</div>
					<div class="listBox" style="margin-top: 6px;">
						<div class="label">包装数量：</div>
						<div class="label ml-6">{{unit+$global.unit+'/'+$global.pack}}</div>
					</div>
					<div class="listBox" style="margin-top: 6px;" v-if="$common.hasLimits('stockInfo')">
						<div class="label">库存：</div>
						<div class="label ml-6" :class="{'red':maxstock-minstock<=0}">{{stockDesc}}</div>
					</div>
					<div class="listBox" style="margin-top: 6px;" v-if="$global.buyType!=2">
						<div class="label">购买{{$global.pack}}数：</div>
						<div class="label ml-6">
							<InNumber
								:datainfo="item"
								:dataKey="'buyCount'"
								@changeEnd="changeEnd($event,'buyCount')"
							></InNumber>
						</div>
					</div>
					<div class="listBox" style="margin-top: 6px;" v-if="$global.buyType!=1">
						<div class="label">购买{{$global.unit}}数：</div>
						<div class="label ml-6">
							<InNumber
								:datainfo="item"
								:dataKey="'buyNumber'"
								@changeEnd="changeEnd($event,'buyNumber')"
							></InNumber>
						</div>
					</div>
					<div class="btns mt-12">
						<el-button type="primary" icon="el-icon-shopping-cart-2" @click="addOne()">加入购物车</el-button>
						<el-button type="success" @click="moreBuyDialog=true">多选模式</el-button>
						
						<!-- <div class="favbtn"><img src="../../assets/favorites.png" height="16">
							<div class="ml-6">已收藏</div>
						</div> -->
					</div>
					
				</div>
			</div>
			<el-tabs class="introduction mt-12">
				<el-tab-pane label="商品介绍" name="first">
					<div style="font-size:14px;margin-top: 6px;">{{remark}}</div>
				</el-tab-pane>
			</el-tabs>
		</el-card>
		<el-dialog :title="name" :visible.sync="moreBuyDialog" width="60%">
			<Scope
				:tableData="tableData"
				:packing="packing"
				:hasshopingcart="true"
				@close="close"
				@addToShopingcart="addToShopingcart"
			></Scope>
		</el-dialog>
	</div>
</template>

<script>
import Scope from '../../components/scope.vue';
	export default {
		components:{
			Scope,
		},
		data() {
			return {
				moreBuyDialog: false,
				item:{
					buyNumber: 0,
					buyCount: 0,
				},
				curGroup: 1,
				curIndex: 0,
				curColorIndex: 0,
				curSizeIndex: 0,
				unit:0,
				stockDesc:'',
				imgs: [],
				spec:[],
				price:0,
				retail:0,
				tableData: [],
				packing:"",
				minstock:0,
				maxstock:0,
				name:'',
				number:"",
				remark:"",
				spkey:0,
				id:0,
			};
		},
		created() {
			let ski = this.$route.query.id;
			let obj = {
				id:ski,
			}
			this.id = ski;
			this.$api.productDetail(obj).then((res)=>{
				if(res.data.code==1){
					let info = res.data.data;
					this.updateSpecs(info);
					this.tableData = info.specs;
					this.packing = info.packing;
					this.minstock = info.minstock;
					this.updatePrice(this.curColorIndex,this.curSizeIndex);
					this.name = info.name;
					this.number = info.number;
					this.remark = info.remark;
					if(info.img.length>0){
						info.img.forEach(e => {
							if(e!=null&&e!=""){
								this.imgs.push(this.$api.baseURL+e);
							}else{
								this.imgs.push("");
							}
						});
					}
				}
			})
		},
		methods: {
			close(){
				this.moreBuyDialog = false;
			},
			changeEnd(e,val){
				this.item[val] = e;
			},
			updateSpecs(info){
				info.specs.forEach(e=>{
					e.maxstock = e.stock-e.notSendUnit;
					e.stockDesc = this.$common.changeSendDesc(e.stock-e.notSendUnit,e.unit);
					e.num = 0;
					e.count = 0;
					let color = e.color;
					let size = e.size;
					let exist = false;
					for(let i=0;i<this.spec.length;i++){
						let cc = this.spec[i];
						if(cc.color==color){
							if(cc.sizes==null){
								cc.sizes=[];
							}
							if(cc.sizes.indexOf(size)==-1){
								cc.sizes.push(size);
							}
							exist = true;
						}
					}
					if(!exist){
						let obj = {
							color:color,
							sizes:[size],
						}
						this.spec.push(obj);
					}
				})
			},
			updatePrice(colorid,sizeid){
				let color = this.spec[colorid].color;
				let size = this.spec[colorid].sizes[sizeid];
				let exist = false;
				for(let i=0;i<this.tableData.length;i++){
					let sp = this.tableData[i];
					if(sp.color==color&&sp.size==size){
						exist = true;
						this.spkey = sp.id;
						this.price = sp.price;
						this.retail = sp.retail;
						this.unit = sp.unit;
						this.stockDesc = sp.stockDesc;
						this.maxstock = sp.maxstock;
						this.minstock = sp.minstock;
						break;
					}
				}
				if(!exist){
					this.spkey = -1;
					this.price = 0;
					this.retail = 0;
				}
			},
			toBack() {
				this.$router.push({
					path: '/product'
				});
			},
			chooseColor(index) {
				if(index==this.curColorIndex){
					return;
				}
				let size = this.spec[this.curColorIndex].sizes[this.curSizeIndex];
				this.curColorIndex = index;
				let index2 = 0;
				for(let i=0;i<this.spec[this.curColorIndex].sizes.length;i++){
					let temp = this.spec[this.curColorIndex].sizes[i];
					if(temp==size){
						index2 = i;
						break;
					}
				}
				this.curSizeIndex = index2;
				this.updatePrice(this.curColorIndex,this.curSizeIndex);
			},
			chooseSize(index) {
				if(index==this.curSizeIndex){
					return;
				}
				this.curSizeIndex = index;
				this.updatePrice(this.curColorIndex,this.curSizeIndex);
			},
			addToShopingcart(){
				let count = 0;
				let addcount = 0;
				this.tableData.forEach(e=>{
					if(e.num>0||e.count>0){
						let color = e.color;
						let size = e.size;
						let key = this.addShopingCart(color,size,e.id,e.num,e.count);
						if(typeof key == 'boolean'){
							if(key){
								count++;
							}else{
								addcount++;
							}
						}
					}
					e.num = 0;
					e.count = 0;
				})
				let msg = "";
				if(count>0||addcount>0){
					if(count>0){
						msg += '成功添加了'+count+'件产品 ';
					}
					if(addcount>0){
						msg += '有'+addcount+'件产品增加了数量 ';
					}
					this.$common.success(msg);
				}else{
					this.$common.success("添加失败");
				}
				this.moreBuyDialog = false;
			},
			addOne(){
				let color = this.spec[this.curColorIndex].color;
				let size = this.spec[this.curColorIndex].sizes[this.curSizeIndex];
				if(this.item.buyNumber<1&&this.item.buyCount<1){
					return;
				}
				let addsucc = this.addShopingCart(color,size,this.spkey,this.item.buyNumber,this.item.buyCount);
				if(typeof addsucc == 'boolean'){
					if(addsucc){
						this.$common.success("添加成功");
					}else{
						this.$common.success("增加数量");
					}
				}else{
					this.$common.success("添加失败");
				}

			},
			addShopingCart(color,size,spkey,num,count){
				if(num<1&&count<1){
					return null;
				}
				if(color==null||size==null){
					return null;
				}
				let shopingcart = JSON.parse(localStorage.getItem("shopingcart"));
				let exist = false;
				let index = -1;
				if(shopingcart!=null){
					for(let i in shopingcart){
						if(shopingcart[i].id==this.id&&shopingcart[i].spid==spkey){
							index = i;
							break;
						}
					}
				}else{
					shopingcart = [];
				}
				if(index>=0){
					let obj = shopingcart.splice(index,1)[0];
					obj.count = parseInt(obj.count)+parseInt(count);
					obj.num = parseInt(obj.num)+parseInt(num);
					shopingcart.unshift(obj);
					localStorage.setItem("shopingcart",JSON.stringify(shopingcart));
					return false;
				}else{
					let obj = {
						id:this.id,
						spid:spkey,
						imgpath:this.imgs,
						number:this.number,
						name:this.name,
						color: color,
						size: size,
						packing:this.packing,
						price : this.price,
						money : this.retail,
						count: count?count:0,
						num:num?num:0,
						unit:this.unit,
					}
					shopingcart.unshift(obj);
					this.$global.shoppingCartNumber = shopingcart.length;
					localStorage.setItem("shopingcart",JSON.stringify(shopingcart));
					return true;
				}
			},
			leftImg(){
				if(this.curIndex>0){
					this.curIndex--;
				}
			},
			rightImg(){
				if(this.curIndex<this.imgs.length-1){
					this.curIndex++;
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	.clearfix {
		.left {
			display: flex;
			align-items: center;
			.iconfont {
				color: #333940;
				font-size: 18px;	
			}
		}
	}
	.erroricon{
		width: 250px;
		line-height: 250px;
		font-size: 40px;
		text-align: center;
	}
	.proHead {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;

		.left {
			width: 249px;
			margin-right: 20px;

			.curImg {
				width: 249px;
				height: 249px;
			}

			.imgBox {
				padding: 14px 20px;
				position: relative;

				.prevbtn {
					position: absolute;
					left: 0;
					top: 14px;
					height: 36px;
				}

				.nextbtn {
					position: absolute;
					right: 0;
					top: 14px;
					height: 36px;
				}

				.imglist {
					display: flex;
					align-items: center;

					.imgitem {
						width: 36px;
						height: 36px;
						margin: 0 3px;
					}

					.chooseImg {
						border: 1px solid #1F8FFF;
					}
				}
			}
		}

		.right {
			width: 100%;

			.proTitle {
				font-size: 18px;
				font-weight: bold;
				color: #333940;
			}

			.proInfo {
				font-size: 14px;
				font-weight: 400;
				color: #919599;

				span {
					padding-right: 30px;
				}
			}

			.priceBox {
				background: #F3F3F3;
				font-size: 14px;
				font-weight: 400;
				color: #333940;
				line-height: 30px;
				padding: 3px 15px;

				.orderP {
					font-size: 18px;
					color: #E60012;
				}
			}

			.listBox {
				display: flex;
				align-items: center;

				.label {
					font-size: 14px;
					font-weight: 400;
					color: #333940;
					line-height: 26px;
				}

				.colorlist {
					display: flex;
					align-items: center;
					flex-wrap: wrap;

					.coloritem {
						margin: 6px;
						height: 23px;
						background: #F2F3F5;
						border: 1px solid #D2D5D9;
						font-size: 14px;
						font-weight: 400;
						color: #333940;
						text-align: center;
						line-height: 23px;
						padding: 0 10px;
						position: relative;

						img {
							position: absolute;
							top: 0;
							right: 0;
						}
					}
					.checkedColor {
						border: 1px solid #1F8FFF;
					}
				}
			}

			.btns {
				display: flex;
				align-items: center;

				.carbtn {
					display: flex;
					align-items: center;
					background: #1F8FFF;
					padding: 8px 16px;
					font-size: 13px;
					font-weight: 400;
					color: #FFFFFF;
				}

				.favbtn {
					margin-left: 28px;
					display: flex;
					align-items: center;
					background: #F2F2F2;
					padding: 8px 16px;
					font-size: 13px;
					font-weight: 400;
					color: #333940;
				}
			}

			.moreBuy {
				font-size: 17px;
				font-weight: 400;
				color: #1F8FFF;
			}
		}
	}

	.mt-12 {
		margin-top: 12px;
	}

	.ml-6 {
		margin-left: 6px;
	}

</style>
